class AfterpayModal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    this.trigger = document.querySelector(".modal-trigger");
    this.closeBtn = this.modal.querySelector(".modal-close");
    this.overlay = this.modal.querySelector(".modal-overlay");
    this.modalContent = this.modal.querySelector(".modal-content");

    this.init();
  }

  init() {
    this.trigger.addEventListener("click", () => this.openModal());
    this.closeBtn.addEventListener("click", () => this.closeModal());
    this.overlay.addEventListener("click", () => this.closeModal());
    document.addEventListener("click", (event) => this.handleOutsideClick(event));
  }

  openModal() {
    this.modal.classList.remove("hidden");
    setTimeout(() => {
      this.modalContent.classList.add("scale-in");
    }, 100);
  }

  closeModal() {
    this.modal.classList.add("hidden");
    this.modalContent.classList.remove("scale-in");
  }

  handleOutsideClick(event) {
    if (this.modal && !this.modal.classList.contains("hidden")) {
      if (!this.modalContent.contains(event.target) && !this.trigger.contains(event.target)) {
        this.closeModal();
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new AfterpayModal("afterpay-modal");
});
